import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  items: [],
  status: "idle",
  error: null,
};

//data fetching

export const thumbImageFetching = createAsyncThunk(
  "thumbImage/thumbImageFetching",
  async (productId) => {
    const res = await axios.get(
      `${process.env.REACT_APP_URL}/api-thumb/${productId}`
    );
    return res.data;
  }
);

export const thumbImageSlice = createSlice({
  name: "thumbImage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(thumbImageFetching.pending, (state, action) => {
      state.status = "loading...";
    });
    builder.addCase(thumbImageFetching.fulfilled, (state, action) => {
      state.status = "success";
      state.items = action.payload;
    });
    builder.addCase(thumbImageFetching.rejected, (state, action) => {
      state.status = "Failed";
      state.error = action.error.message;
    });
  },
});

export default thumbImageSlice.reducer;
